var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "elevation-8 main-menu-panel",
      attrs: {
        "hide-overlay": "",
        fixed: "",
        "expand-on-hover": "",
        "mini-variant-width": 80,
        width: 325,
        "mini-variant": _vm.mini,
        touchless: "",
        permanent: ""
      },
      on: {
        "update:miniVariant": function($event) {
          _vm.mini = $event
        },
        "update:mini-variant": function($event) {
          _vm.mini = $event
        }
      }
    },
    [
      _c("main-menu-header"),
      _c(
        "v-list",
        { staticStyle: { "white-space": "nowrap", width: "325px" } },
        [
          _vm.isAdminUser ? _c("main-menu-admin") : _vm._e(),
          !_vm.isWnbUser && !_vm.isAdminUser
            ? _c("main-menu-standalone")
            : _vm._e(),
          _vm.is_user_logged()
            ? _c(
                "v-list-item",
                {
                  staticStyle: { "border-top": "1px solid rgba(0,0,0,.12)" },
                  attrs: { to: "/logout" }
                },
                [
                  _c(
                    "v-list-item-action",
                    [_c("v-icon", [_vm._v("exit_to_app")])],
                    1
                  ),
                  _c("v-list-item-content", [
                    _vm._v(_vm._s(_vm.$t("global.menu.logOut")))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isWnbUser && !_vm.isAdminUser ? _c("main-menu-w-n-b") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }